import _ from 'lodash'
import * as api from '../api/jewelry'

export const setFilterVal = (key, value) => {
  return {
    type: 'SET_JEWELRY_SEARCH_FILTER_VALUE',
    key: key,
    value: value
  }
}

export const openModal = (data, additionalNotes) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_JEWELRY_MODAL_DATA',
      value: { data, additionalNotes }
    })
    dispatch({ type: 'OPEN_MODAL', value: 'jewelry' })
  }
}

export const closeModal = () => {
  return {
    type: 'CLOSE_MODAL'
  }
}

export const clearCurrentJewelry = () => {
  return {
    type: 'CLEAR_CURRENT_JEWELRY'
  }
}

export const search = () => {
  return (dispatch, getState) => {
    api
      .jewelrySearch(getState().jewelrySearch.filters)
      .then(res => dispatch(setResult(res.data)))
      .catch(error =>
        dispatch(setErrorMsg(JSON.stringify(error.response.data['error'])))
      )
  }
}

export const reset = () => {
  return {
    type: 'RESET_JEWELRY_SEARCH'
  }
}

export const smallDiamondsSearch = () => {
  return (dispatch, getState) => {
    if (
      getState().jewelrySearch.filters.multi_stone_shape &&
      getState().jewelrySearch.filters.multi_stone_shape[0] &&
      getState().jewelrySearch.filters.multi_stone_quality
    ) {
      api
        .getSmallDiamondsByShapeAndQuality(
          getState().jewelrySearch.filters.multi_stone_shape[0],
          getState().jewelrySearch.filters.multi_stone_quality
        )
        .then(res =>
          dispatch(
            setMultiStoneSizes(
              res.data.map(smallDiamond => ({
                value: smallDiamond['id'],
                label: smallDiamond['dimension']
              }))
            )
          )
        )
    }
  }
}

const setMultiStoneSizes = result => {
  return {
    type: 'SET_MULTI_STONE_SIZE_OPTIONS',
    value: result
  }
}

const setResult = result => {
  return {
    type: 'SET_JEWELRY_SEARCH_RESULT',
    value: result
  }
}

export const setErrorMsg = errorMsg => {
  return {
    type: 'SET_ERROR_MSG',
    value: errorMsg
  }
}

export const addAdditionalDiamond = () => {
  return {
    type: 'ADD_ADDITIONAL_DIAMOND'
  }
}

export const removeAdditionalDiamond = id => {
  return {
    type: 'REMOVE_ADDITIONAL_DIAMOND',
    id
  }
}

export const updateAdditionalDiamond = (id, field, value) => {
  return {
    type: 'UPDATE_ADDITIONAL_DIAMOND',
    id,
    field,
    value
  }
}

export const setAdditionalDiamondSizeOptions = (id, shape, quality) => {
  return dispatch => {
    return api.getSmallDiamondsByShapeAndQuality(shape, quality).then(result => {
      const options = result.data.map(smallDiamond => ({
        value: smallDiamond['id'],
        label: smallDiamond['dimension']
      }))
      dispatch({ type: 'SET_ADDITIONAL_DIAMOND_SIZE_OPTIONS', id, options })
    })
  }
}

export const setVerticalShankThicknesses = () => {
  return dispatch => {
    return api.getVerticalShankThicknesses().then(result => {
      const options = result.data.map(verticalThickness => ({
        value: `${verticalThickness['thickness_in_mm']}${_.snakeCase(verticalThickness['option_name'])}`,
        label: `${verticalThickness['option_name']} (${verticalThickness['thickness_in_mm']}mm)`
      }))
      dispatch({ type: 'SET_VERTICAL_SHANK_THICKNESS', options })
    })
  }
}

export const setDefaultShankWidths = () => {
  return dispatch => {
    return api.getDefaultShankWidths().then(result => {
      const options = result.data.map(defaultShankWidth => ({
        value: `${defaultShankWidth['width_in_mm']}${_.snakeCase(defaultShankWidth['option_name'])}`,
        label: `${defaultShankWidth['option_name']} (${defaultShankWidth['width_in_mm']}mm)`
      }))
      dispatch({ type: 'SET_DEFAULT_SHANK_WIDTH', options })
    })
  }
}

export const setDefaultHaloWidths = () => {
  return dispatch => {
    return api.getDefaultHaloWidths().then(result => {
      const options = result.data.map(defaultHaloWidth => ({
        value: `${defaultHaloWidth['width_in_mm']}${_.snakeCase(defaultHaloWidth['option_name'])}`,
        label: `${defaultHaloWidth['option_name']} (${defaultHaloWidth['width_in_mm']}mm)`
      }))
      dispatch({ type: 'SET_DEFAULT_HALO_WIDTH', options })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/jewelry-search.js